import section6 from "./arbeiten-am-bemassten-grundriss.jpg";
import section1 from "./bemasster-grundriss-auf-laptop.jpg";
import section4 from "./bemasster-grundriss-fuer-bank.jpg";
import section2 from "./bemasster-grundriss-fuer-kreditentscheidung.webp";
import {
  default as header,
  default as section5,
} from "./dokument-wohnflächenberechnung.png";
import section3 from "./dokumente-eines-bemassten-grundrisses.jpg";

export { header, section1, section2, section3, section4, section5, section6 };
